/*
  Vibranet — modulo "Diventa rivenditore" (sezione vbx-b2b-join).

  I dati fiscali seguono il paese della sede: la partita IVA prende nome e formato
  locali (USt-IdNr., NIF-IVA, DIČ...) e compaiono gli identificativi che in quel paese
  servono davvero: registro imprese, SIRET, KvK, IČO e, dove esiste, l'equivalente dello
  SDI per la fattura elettronica (Peppol in Belgio, E-Rechnung in Germania, annuario della
  riforma in Francia, verkkolaskuosoite in Finlandia, EAN in Danimarca).

  L'invio passa dal modulo contatti di Shopify: tutti i campi finiscono in contact[body]
  con etichette in italiano, per chi gestisce le richieste.
*/
(function () {
  const form = document.getElementById('VibranetB2BRegister');
  if (!form) return;

  // Testi localizzati passati dal Liquid: senza il blocco JSON restano in italiano.
  const I18N = (() => {
    const fallback = {
      locale: 'it',
      select: 'Seleziona',
      err_required: 'Completa i campi obbligatori evidenziati.',
      err_invalid: 'Controlla i dati inseriti nei campi evidenziati.',
      err_vat: 'Il formato della partita IVA non sembra valido per il paese selezionato.',
      err_sdi_pec: 'Per aziende italiane inserisci Codice SDI oppure PEC.',
      err_field_format: 'Controlla il formato del campo',
      vat: 'Partita IVA / VAT number',
      vat_help: 'Inserisci il prefisso paese quando disponibile.',
      vat_help_auto_1: 'Il prefisso',
      vat_help_auto_2: 'viene applicato automaticamente se non lo inserisci.',
      vat_placeholder_generic: 'Es. VAT number',
      sdi_help: 'Obbligatorio in alternativa alla PEC.',
      pec_help: 'Obbligatoria se non inserisci il codice SDI.',
      fx_vat: 'Partita IVA comunitaria',
      fx_optional: 'facoltativo',
    };
    try {
      const node = document.getElementById('VibranetB2BRegisterI18n');
      if (!node) return fallback;
      // Il filtro t di Liquid restituisce testo con entita' HTML (l&#39;impresa): qui serve testo puro.
      const decoder = document.createElement('textarea');
      const parsed = JSON.parse(node.textContent);
      Object.keys(parsed).forEach((key) => {
        decoder.innerHTML = parsed[key];
        parsed[key] = decoder.value;
      });
      return Object.assign({}, fallback, parsed);
    } catch (error) {
      return fallback;
    }
  })();

  /*
    Paesi. vat: nome locale, esempio e formato completo di prefisso.
    fields: campi in piu' per quel paese. kind sceglie il testo di aiuto tradotto
    (vibranet.register.fx_<kind>) e l'etichetta italiana nel messaggio (NOTE_KIND).
    clean: 'upper' toglie gli spazi e mette in maiuscolo, 'digits' tiene solo le cifre.
  */
  const COUNTRIES = {
    AT: {
      vat: { label: 'UID-Nummer', example: 'ATU12345678', pattern: /^ATU\d{8}$/ },
      fields: [{ id: 'RegAT', kind: 'reg', label: 'Firmenbuchnummer', example: 'FN 123456a', clean: 'upper', pattern: /^(FN)?\d{1,6}[A-Z]$/ }],
    },
    BE: {
      vat: { label: 'Numéro de TVA / btw-nummer', example: 'BE0123456789', pattern: /^BE[01]\d{9}$/ },
      fields: [{ id: 'PeppolBE', kind: 'peppol_be', label: 'Peppol ID', example: '0208:0123456789', clean: 'upper', pattern: /^\d{4}:[A-Z0-9]{4,}$/ }],
    },
    BG: {
      vat: { label: 'ИН по ДДС', example: 'BG123456789', pattern: /^BG\d{9,10}$/ },
      fields: [],
    },
    CY: {
      vat: { label: 'Αριθμός ΦΠΑ / VAT number', example: 'CY12345678L', pattern: /^CY\d{8}[A-Z]$/ },
      fields: [{ id: 'RegCY', kind: 'reg', label: 'Registration number', example: 'HE 123456', clean: 'upper', pattern: /^[A-ZΑ-Ω]{0,3}\d{1,6}$/ }],
    },
    CZ: {
      vat: { label: 'DIČ', example: 'CZ12345678', pattern: /^CZ\d{8,10}$/ },
      fields: [{ id: 'IcoCZ', kind: 'id', label: 'IČO', example: '12345678', clean: 'digits', pattern: /^\d{8}$/, required: true }],
    },
    DE: {
      vat: { label: 'USt-IdNr.', example: 'DE123456789', pattern: /^DE\d{9}$/ },
      fields: [
        { id: 'RegDE', kind: 'reg', label: 'Handelsregisternummer', example: 'HRB 12345, Amtsgericht München' },
        { id: 'EinvDE', kind: 'einv', label: 'E-Rechnungsadresse', example: 'rechnung@firma.de', pattern: /^([^\s@]+@[^\s@]+\.[^\s@]+|\d{4}:\S+)$/ },
      ],
    },
    DK: {
      vat: { label: 'CVR-/SE-nummer', example: 'DK12345678', pattern: /^DK\d{8}$/ },
      fields: [{ id: 'EanDK', kind: 'ean_dk', label: 'EAN-nummer', example: '5790001234567', clean: 'digits', pattern: /^\d{13}$/ }],
    },
    EE: {
      vat: { label: 'KMKR number', example: 'EE123456789', pattern: /^EE\d{9}$/ },
      fields: [{ id: 'RegEE', kind: 'reg', label: 'Registrikood', example: '12345678', clean: 'digits', pattern: /^\d{8}$/ }],
    },
    ES: {
      vat: { label: 'NIF-IVA', example: 'ESB12345678', pattern: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/ },
      fields: [],
    },
    FI: {
      vat: { label: 'ALV-numero', example: 'FI12345678', pattern: /^FI\d{8}$/ },
      fields: [
        { id: 'EinvFI', kind: 'einv_fi', label: 'Verkkolaskuosoite', example: '003712345678', clean: 'upper', pattern: /^[A-Z0-9]{8,35}$/ },
        { id: 'OperatorFI', kind: 'operator_fi', label: 'Välittäjän tunnus', example: '003721291126', clean: 'upper', pattern: /^[A-Z0-9]{4,20}$/ },
      ],
    },
    FR: {
      vat: { label: 'Numéro de TVA intracommunautaire', example: 'FR12345678901', pattern: /^FR[A-HJ-NP-Z0-9]{2}\d{9}$/ },
      fields: [
        { id: 'SiretFR', kind: 'siret', label: 'SIRET', example: '123 456 789 00012', clean: 'digits', pattern: /^\d{14}$/, required: true },
        { id: 'EinvFR', kind: 'einv_fr', label: 'Adresse de facturation électronique', example: '123456789' },
      ],
    },
    GR: {
      vat: { label: 'ΑΦΜ', example: 'EL123456789', pattern: /^EL\d{9}$/, prefix: 'EL' },
      fields: [{ id: 'GemiGR', kind: 'reg', label: 'Αριθμός ΓΕΜΗ', example: '123456789000', clean: 'digits', pattern: /^\d{9,12}$/ }],
    },
    HR: {
      vat: { label: 'PDV ID broj (OIB)', example: 'HR12345678901', pattern: /^HR\d{11}$/ },
      fields: [],
    },
    HU: {
      vat: { label: 'Közösségi adószám', example: 'HU12345678', pattern: /^HU\d{8}$/ },
      fields: [
        { id: 'TaxHU', kind: 'tax', label: 'Adószám', example: '12345678-2-42', clean: 'upper', pattern: /^\d{8}-?\d-?\d{2}$/ },
        { id: 'RegHU', kind: 'reg', label: 'Cégjegyzékszám', example: '01-09-123456', clean: 'upper', pattern: /^\d{2}-?\d{2}-?\d{6}$/ },
      ],
    },
    IE: {
      vat: { label: 'VAT number', example: 'IE1234567T', pattern: /^IE(\d{7}[A-W][A-IW]?|\d[A-Z+*]\d{5}[A-W])$/ },
      fields: [{ id: 'CroIE', kind: 'reg', label: 'CRO number', example: '123456', clean: 'digits', pattern: /^\d{1,6}$/ }],
    },
    IT: {
      vat: { label: 'Partita IVA', example: 'IT01234567890', pattern: /^IT\d{11}$/ },
      fields: [
        { id: 'SdiCode', kind: 'sdi', label: 'Codice destinatario SDI', note: 'Codice SDI', example: 'M5UXCR1', clean: 'upper', pattern: /^[A-Z0-9]{7}$/, maxlength: 7, help: 'sdi_help' },
        { id: 'PecEmail', kind: 'pec', label: 'PEC', note: 'PEC', type: 'email', example: 'fatture@pec.azienda.it', pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, help: 'pec_help' },
        { id: 'FiscalCode', kind: 'tax', label: 'Codice fiscale', note: 'Codice fiscale', example: '01234567890', clean: 'upper', pattern: /^([A-Z0-9]{16}|\d{11})$/ },
      ],
      oneOf: ['SdiCode', 'PecEmail'],
    },
    LT: {
      vat: { label: 'PVM mokėtojo kodas', example: 'LT123456789', pattern: /^LT(\d{9}|\d{12})$/ },
      fields: [{ id: 'RegLT', kind: 'reg', label: 'Įmonės kodas', example: '123456789', clean: 'digits', pattern: /^\d{9}$/ }],
    },
    LU: {
      vat: { label: 'Numéro de TVA', example: 'LU12345678', pattern: /^LU\d{8}$/ },
      fields: [{ id: 'RegLU', kind: 'reg', label: 'Numéro RCS', example: 'B123456', clean: 'upper', pattern: /^[A-Z]\d{1,6}$/ }],
    },
    LV: {
      vat: { label: 'PVN reģistrācijas numurs', example: 'LV12345678901', pattern: /^LV\d{11}$/ },
      fields: [],
    },
    MT: {
      vat: { label: 'VAT number', example: 'MT12345678', pattern: /^MT\d{8}$/ },
      fields: [{ id: 'RegMT', kind: 'reg', label: 'Company registration number', example: 'C 12345', clean: 'upper', pattern: /^[A-Z]{1,2}\d{1,6}$/ }],
    },
    NL: {
      vat: { label: 'Btw-identificatienummer', example: 'NL123456789B01', pattern: /^NL\d{9}B\d{2}$/ },
      fields: [{ id: 'KvkNL', kind: 'reg', label: 'KvK-nummer', example: '12345678', clean: 'digits', pattern: /^\d{8}$/, required: true }],
    },
    PL: {
      vat: { label: 'NIP UE', example: 'PL1234567890', pattern: /^PL\d{10}$/ },
      fields: [{ id: 'KrsPL', kind: 'reg', label: 'KRS / REGON', example: '0000123456', clean: 'digits', pattern: /^(\d{9}|\d{10}|\d{14})$/ }],
    },
    PT: {
      vat: { label: 'NIF / NIPC', example: 'PT123456789', pattern: /^PT\d{9}$/ },
      fields: [{ id: 'CertPT', kind: 'cert_pt', label: 'Código da certidão permanente', example: '1234-5678-9012', clean: 'upper', pattern: /^\d{4}-?\d{4}-?\d{4}$/ }],
    },
    RO: {
      vat: { label: 'Cod de TVA (CUI)', example: 'RO12345678', pattern: /^RO\d{2,10}$/ },
      fields: [{ id: 'RegRO', kind: 'reg', label: 'Nr. Registrul Comerțului', example: 'J40/1234/2020', clean: 'upper', pattern: /^([JFC]\d{1,2}\/\d{1,7}\/\d{4}|[JFC]\d{13})$/ }],
    },
    SE: {
      vat: { label: 'Momsregistreringsnummer', example: 'SE123456789001', pattern: /^SE\d{10}01$/ },
      fields: [],
    },
    SI: {
      vat: { label: 'ID za DDV', example: 'SI12345678', pattern: /^SI\d{8}$/ },
      fields: [{ id: 'RegSI', kind: 'reg', label: 'Matična številka', example: '1234567000', clean: 'digits', pattern: /^\d{7}(\d{3})?$/ }],
    },
    SK: {
      vat: { label: 'IČ DPH', example: 'SK1234567890', pattern: /^SK\d{10}$/ },
      fields: [{ id: 'IcoSK', kind: 'id', label: 'IČO', example: '12345678', clean: 'digits', pattern: /^\d{8}$/, required: true }],
    },
    OTHER: {
      vat: null,
      fields: [{ id: 'RegOTHER', kind: 'reg', label: null }],
    },
  };

  /* Etichette italiane dei campi fiscali nel messaggio che arriva al negozio. */
  const NOTE_KIND = {
    reg: 'Registro imprese',
    id: 'Numero identificativo impresa',
    tax: 'Codice fiscale nazionale',
    siret: 'SIRET',
    einv: 'Indirizzo fattura elettronica',
    einv_fr: 'Indirizzo fattura elettronica',
    einv_fi: 'Indirizzo fattura elettronica',
    operator_fi: 'Operatore fattura elettronica',
    peppol_be: 'ID Peppol',
    ean_dk: 'EAN fattura elettronica',
    cert_pt: 'Codice certidão permanente',
  };

  const IT_NAMES = {
    AT: 'Austria', BE: 'Belgio', BG: 'Bulgaria', CY: 'Cipro', HR: 'Croazia', DK: 'Danimarca', EE: 'Estonia',
    FI: 'Finlandia', FR: 'Francia', DE: 'Germania', GR: 'Grecia', IE: 'Irlanda', IT: 'Italia', LV: 'Lettonia',
    LT: 'Lituania', LU: 'Lussemburgo', MT: 'Malta', NL: 'Paesi Bassi', PL: 'Polonia', PT: 'Portogallo',
    CZ: 'Repubblica Ceca', RO: 'Romania', SK: 'Slovacchia', SI: 'Slovenia', ES: 'Spagna', SE: 'Svezia', HU: 'Ungheria',
  };

  /* Nome del paese nelle opzioni di Shopify (all_country_option_tags): serve per le province. */
  const SHOPIFY_NAMES = {
    AT: ['Austria'], BE: ['Belgium'], BG: ['Bulgaria'], CY: ['Cyprus'], HR: ['Croatia'], DK: ['Denmark'],
    EE: ['Estonia'], FI: ['Finland'], FR: ['France'], DE: ['Germany'], GR: ['Greece'], IE: ['Ireland'],
    IT: ['Italy'], LV: ['Latvia'], LT: ['Lithuania'], LU: ['Luxembourg'], MT: ['Malta'], NL: ['Netherlands'],
    PL: ['Poland'], PT: ['Portugal'], CZ: ['Czechia', 'Czech Republic'], RO: ['Romania'], SK: ['Slovakia'],
    SI: ['Slovenia'], ES: ['Spain'], SE: ['Sweden'], HU: ['Hungary'],
  };

  const PHONE_PREFIX = {
    AT: '+43', BE: '+32', BG: '+359', CY: '+357', CZ: '+420', DE: '+49', DK: '+45', EE: '+372', ES: '+34',
    FI: '+358', FR: '+33', GR: '+30', HR: '+385', HU: '+36', IE: '+353', IT: '+39', LT: '+370', LU: '+352',
    LV: '+371', MT: '+356', NL: '+31', PL: '+48', PT: '+351', RO: '+40', SE: '+46', SI: '+386', SK: '+421',
  };

  const EU_VAT_PREFIXES = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];

  const $ = (selector) => form.querySelector(selector);
  const country = $('[data-b2b-country]');
  const otherWrap = $('[data-other-country]');
  const otherCountry = $('#OtherCountry');
  const provinceWrap = $('[data-province-field]');
  const province = $('[data-province]');
  const vat = $('[data-vat-field]');
  const vatLabel = $('[data-vat-label]');
  const vatHelp = $('[data-vat-help]');
  const fiscalFields = $('[data-fiscal-fields]');
  const fiscalEmpty = $('[data-fiscal-empty]');
  const shipToggle = $('[data-ship-toggle]');
  const shipBlock = $('[data-ship-block]');
  const shipCountry = $('[data-ship-country]');
  const shipProvinceWrap = $('[data-ship-province-field]');
  const shipProvince = $('[data-ship-province]');
  const note = $('.vb-b2b-note');
  const nameField = $('[data-join-name]');
  const errorBox = $('[data-register-error]');
  const phonePrefix = $('[data-phone-prefix]');
  const phoneNumber = $('[data-phone-number]');
  const phoneFull = $('[data-phone-full]');
  const phoneFlag = $('[data-phone-flag]');
  const draftStorageKey = 'vibranetB2BRegisterDraft';
  let draft = {};

  const config = () => COUNTRIES[country ? country.value : ''] || null;

  // ------------------------------------------------------------ utilita'

  function cleanValue(value, mode) {
    const text = String(value || '').trim();
    if (mode === 'digits') return text.replace(/[\s.\-/]/g, '');
    if (mode === 'upper') return text.replace(/\s+/g, '').toUpperCase();
    return text;
  }

  function setError(message) {
    errorBox.hidden = !message;
    errorBox.textContent = message || '';
  }

  function markInvalid(input, message) {
    input.closest('.vb-field, .vb-checkbox')?.classList.add('is-invalid');
    setError(message);
    input.focus();
    return false;
  }

  function sortOptions(select, keepLast) {
    if (!select) return;
    const options = Array.from(select.options);
    const head = options.filter((o) => !o.value);
    const tail = options.filter((o) => keepLast && o.value === keepLast);
    const body = options.filter((o) => o.value && o.value !== keepLast);
    const collator = new Intl.Collator(document.documentElement.lang || I18N.locale || 'it');
    body.sort((a, b) => collator.compare(a.textContent.trim(), b.textContent.trim()));
    [...head, ...body, ...tail].forEach((o) => select.appendChild(o));
  }

  function toggleField(wrapper, active) {
    if (!wrapper) return;
    wrapper.classList.toggle('is-hidden', !active);
    wrapper.querySelectorAll('input, select, textarea').forEach((input) => {
      input.disabled = !active;
      if (!active) input.closest('.vb-field')?.classList.remove('is-invalid');
    });
  }

  // ------------------------------------------------------------ province (dati di Shopify)

  /* Province per nome del paese, lette una volta sola dall'elenco completo di Shopify
     (prima che il menu "extra UE" perda i paesi europei). */
  const PROVINCES = new Map(
    otherCountry ? Array.from(otherCountry.options).map((o) => [o.value, o.dataset.provinces || '[]']) : []
  );

  function shopifyName(names) {
    if (!names) return '';
    return [].concat(names).find((name) => PROVINCES.has(name)) || '';
  }

  function provincesOf(name) {
    try {
      return JSON.parse(PROVINCES.get(name) || '[]');
    } catch (error) {
      return [];
    }
  }

  function fillProvinces(select, wrapper, list) {
    if (!select || !wrapper) return;
    const wanted = select.value || draft[select.id] || '';
    select.innerHTML = '';
    if (!list.length) {
      toggleField(wrapper, false);
      select.required = false;
      return;
    }
    select.add(new Option(I18N.select, ''));
    list.forEach(([value, label]) => select.add(new Option(label || value, value)));
    select.value = list.some(([value]) => value === wanted) ? wanted : '';
    toggleField(wrapper, true);
    select.required = true;
  }

  function companyShopifyName() {
    const code = country ? country.value : '';
    if (code === 'OTHER') return otherCountry && otherCountry.value ? [otherCountry.value] : null;
    return SHOPIFY_NAMES[code] || null;
  }

  function updateProvinces() {
    fillProvinces(province, provinceWrap, provincesOf(shopifyName(companyShopifyName())));
  }

  function updateShipProvinces() {
    const hidden = shipBlock.classList.contains('is-hidden');
    fillProvinces(shipProvince, shipProvinceWrap, hidden || !shipCountry ? [] : provincesOf(shipCountry.value));
  }

  /* La consegna segue il paese della sede finche' non se ne sceglie un altro. */
  function defaultShipCountry() {
    const name = shopifyName(companyShopifyName());
    if (!shipCountry || shipCountry.dataset.touched || !name || shipCountry.value === name) return;
    shipCountry.value = name;
    shipProvince.value = '';
  }

  // ------------------------------------------------------------ campi fiscali per paese

  function hintFor(field) {
    const parts = [];
    const described = I18N['fx_' + field.kind];
    if (described) parts.push(described);
    if (field.help && I18N[field.help]) parts.push(I18N[field.help]);
    else if (!field.required) parts.push(I18N.fx_optional);
    return parts.join(' · ');
  }

  function renderFiscalFields(cfg) {
    fiscalFields.innerHTML = '';
    if (!cfg) return;
    cfg.fields.forEach((field) => {
      const label = field.label || I18N.fx_other_reg || NOTE_KIND[field.kind];
      const wrapper = document.createElement('div');
      wrapper.className = 'vb-field';

      const labelNode = document.createElement('label');
      labelNode.htmlFor = field.id;
      labelNode.textContent = label;

      const input = document.createElement('input');
      input.id = field.id;
      input.type = field.type || 'text';
      input.autocomplete = 'off';
      input.spellcheck = false;
      if (field.example) input.placeholder = field.example;
      if (field.maxlength) input.maxLength = field.maxlength;
      if (field.required) input.required = true;
      input.dataset.noteField = '';
      const kindLabel = NOTE_KIND[field.kind];
      input.dataset.noteLabel = field.note || (field.label && field.label !== kindLabel ? kindLabel + ' (' + field.label + ')' : kindLabel);
      if (draft[field.id]) input.value = draft[field.id];

      const help = document.createElement('small');
      help.textContent = hintFor(field);

      wrapper.append(labelNode, input, help);
      fiscalFields.appendChild(wrapper);
    });
    updateOneOf();
  }

  /* Italia: basta uno tra Codice SDI e PEC. */
  function updateOneOf() {
    const cfg = config();
    if (!cfg || !cfg.oneOf) return;
    const inputs = cfg.oneOf.map((id) => document.getElementById(id)).filter(Boolean);
    const anyFilled = inputs.some((input) => input.value.trim());
    inputs.forEach((input) => {
      input.required = !anyFilled;
    });
  }

  function vatPrefix(code) {
    const cfg = COUNTRIES[code];
    return (cfg && cfg.vat && (cfg.vat.prefix || code)) || '';
  }

  /* Aggiunge il prefisso del paese se manca; se ne e' stato scritto un altro lo lascia,
     cosi' la validazione lo segnala invece di cambiarlo di nascosto. */
  function normalizeVat(value, code) {
    const prefix = vatPrefix(code);
    if (!prefix) return String(value || '').trim();
    let clean = String(value || '').replace(/[\s.\-/]/g, '').toUpperCase();
    if (!clean) return clean;
    const aliases = code === 'GR' ? ['EL', 'GR'] : [prefix];
    const own = aliases.find((alias) => clean.startsWith(alias));
    if (own) clean = clean.slice(own.length);
    else if (EU_VAT_PREFIXES.some((p) => clean.startsWith(p)) && /^[A-Z]{2}/.test(clean) && !/^[A-Z]{2}$/.test(clean)) return clean;
    if (code === 'BE' && /^\d{9}$/.test(clean)) clean = '0' + clean;
    return prefix + clean;
  }

  function updateVatField(cfg) {
    const code = country ? country.value : '';
    if (cfg && cfg.vat) {
      const prefix = vatPrefix(code);
      vatLabel.textContent = cfg.vat.label;
      vat.placeholder = cfg.vat.example;
      vatHelp.textContent = I18N.fx_vat + ' · ' + I18N.vat_help_auto_1 + ' ' + prefix + ' ' + I18N.vat_help_auto_2;
      vat.value = normalizeVat(vat.value, code);
    } else if (code === 'OTHER') {
      vatLabel.textContent = I18N.fx_other_vat || I18N.vat;
      vat.placeholder = I18N.vat_placeholder_generic;
      vatHelp.textContent = I18N.vat_help;
    } else {
      vatLabel.textContent = I18N.vat;
      vat.placeholder = I18N.vat_placeholder_generic;
      vatHelp.textContent = I18N.vat_help;
    }
  }

  function applyCountry() {
    const code = country ? country.value : '';
    const cfg = config();
    toggleField(otherWrap, code === 'OTHER');
    if (otherCountry) otherCountry.required = code === 'OTHER';
    if (fiscalEmpty) fiscalEmpty.hidden = Boolean(code);
    updateVatField(cfg);
    renderFiscalFields(cfg);
    updateProvinces();
    defaultShipCountry();
    updateShipProvinces();
  }

  // ------------------------------------------------------------ consegna e telefono

  function applyShip() {
    const active = Boolean(shipToggle && shipToggle.checked);
    toggleField(shipBlock, active);
    if (shipCountry) shipCountry.required = active;
    if (active) defaultShipCountry();
    updateShipProvinces();
  }

  function syncPhone() {
    const selected = phonePrefix?.selectedOptions?.[0];
    const flag = selected?.dataset.country || 'xx';
    const number = phoneNumber?.value.trim() || '';
    if (phoneFlag) phoneFlag.className = 'vb-phone-flag vb-phone-flag--' + flag;
    if (phoneFull) phoneFull.value = number ? [phonePrefix?.value, number].filter(Boolean).join(' ') : '';
  }

  function syncPhonePrefixWithCountry() {
    const prefix = PHONE_PREFIX[country ? country.value : ''];
    if (!phonePrefix || !prefix || phoneNumber?.value.trim()) return;
    phonePrefix.value = prefix;
    syncPhone();
  }

  // ------------------------------------------------------------ bozza (sessionStorage)

  function draftFields() {
    return Array.from(form.querySelectorAll('input[id], select[id], textarea[id]')).filter((input) => input.type !== 'hidden');
  }

  function saveDraft() {
    draftFields().forEach((input) => {
      draft[input.id] = input.type === 'checkbox' ? input.checked : input.value;
    });
    try {
      sessionStorage.setItem(draftStorageKey, JSON.stringify(draft));
    } catch (error) {}
  }

  function readDraft() {
    try {
      return JSON.parse(sessionStorage.getItem(draftStorageKey) || 'null') || {};
    } catch (error) {
      return {};
    }
  }

  function restoreStatic() {
    draftFields().forEach((input) => {
      if (!(input.id in draft)) return;
      if (input.type === 'checkbox') input.checked = Boolean(draft[input.id]);
      else if (input.tagName !== 'SELECT' || Array.from(input.options).some((o) => o.value === draft[input.id])) input.value = draft[input.id];
    });
  }

  // ------------------------------------------------------------ messaggio per il negozio

  function noteValue(input) {
    if (input.type === 'checkbox') return input.checked ? input.value || 'Si' : '';
    if (input === country) {
      if (input.value === 'OTHER') return 'Extra UE';
      return input.value ? (IT_NAMES[input.value] || input.value) + ' (' + input.value + ')' : '';
    }
    return String(input.value || '').trim();
  }

  function collectNote() {
    const lines = ['Richiesta account B2B Vibranet', 'Lingua del sito: ' + I18N.locale];
    form.querySelectorAll('[data-note-field]').forEach((input) => {
      if (input.disabled) return;
      const value = noteValue(input);
      if (value) lines.push((input.dataset.noteLabel || input.id) + ': ' + value);
    });
    note.value = lines.join('\n');
    if (nameField) {
      nameField.value = [$('#RegisterForm-FirstName')?.value, $('#RegisterForm-LastName')?.value].map((v) => (v || '').trim()).filter(Boolean).join(' ');
    }
  }

  // ------------------------------------------------------------ validazione

  function validate() {
    setError('');
    form.querySelectorAll('.is-invalid').forEach((item) => item.classList.remove('is-invalid'));
    updateOneOf();

    const required = Array.from(form.querySelectorAll('input[required], select[required]')).filter((input) => !input.disabled && input.type !== 'hidden');
    const missing = required.find((input) => (input.type === 'checkbox' ? !input.checked : !String(input.value || '').trim()));
    if (missing) {
      const cfg = config();
      if (cfg && cfg.oneOf && cfg.oneOf.includes(missing.id)) {
        cfg.oneOf.forEach((id) => document.getElementById(id)?.closest('.vb-field')?.classList.add('is-invalid'));
        return markInvalid(missing, I18N.err_sdi_pec);
      }
      return markInvalid(missing, I18N.err_required);
    }

    const code = country ? country.value : '';
    const cfg = config();
    if (cfg && cfg.vat) {
      vat.value = normalizeVat(vat.value, code);
      if (!cfg.vat.pattern.test(vat.value)) return markInvalid(vat, I18N.err_vat);
    }

    if (cfg) {
      for (const field of cfg.fields) {
        const input = document.getElementById(field.id);
        if (!input || !input.value.trim()) continue;
        const value = cleanValue(input.value, field.clean);
        if (field.clean) input.value = value;
        if (field.pattern && !field.pattern.test(value)) {
          const label = input.closest('.vb-field')?.querySelector('label')?.textContent || '';
          return markInvalid(input, I18N.err_field_format + ' ' + label + '.');
        }
      }
    }

    // "www.negozio.it" e' un sito valido anche senza https://
    const website = $('#Website');
    if (website && website.value.trim() && !/^https?:\/\//i.test(website.value.trim())) {
      website.value = 'https://' + website.value.trim();
    }

    const invalid = Array.from(form.querySelectorAll('input, select')).find((input) => !input.disabled && !input.checkValidity());
    if (invalid) return markInvalid(invalid, I18N.err_invalid);

    syncPhone();
    collectNote();
    return true;
  }

  function handleSubmit(event) {
    if (validate()) return true;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    return false;
  }

  // ------------------------------------------------------------ avvio

  // Paesi in ordine alfabetico nella lingua della pagina, "Extra UE" in fondo.
  sortOptions(country, 'OTHER');

  // Il menu "extra UE" mostra solo i paesi fuori UE; lo stesso elenco serve per la consegna.
  if (otherCountry) {
    const euNames = new Set(Object.values(SHOPIFY_NAMES).flat());
    if (shipCountry) {
      shipCountry.innerHTML = otherCountry.innerHTML;
      shipCountry.options[0].textContent = I18N.select;
    }
    Array.from(otherCountry.options).forEach((option) => {
      if (euNames.has(option.value)) option.remove();
    });
  }

  draft = readDraft();
  restoreStatic();
  if (shipCountry && draft.ShipDifferent && draft.ShipCountry) shipCountry.dataset.touched = '1';
  applyCountry();
  applyShip();
  syncPhone();

  country?.addEventListener('change', () => {
    applyCountry();
    syncPhonePrefixWithCountry();
  });
  otherCountry?.addEventListener('change', () => {
    updateProvinces();
    updateShipProvinces();
  });
  shipToggle?.addEventListener('change', applyShip);
  shipCountry?.addEventListener('change', () => {
    shipCountry.dataset.touched = '1';
    shipProvince.value = '';
    updateShipProvinces();
  });
  vat?.addEventListener('blur', () => {
    vat.value = normalizeVat(vat.value, country ? country.value : '');
  });
  phonePrefix?.addEventListener('change', syncPhone);
  phoneNumber?.addEventListener('input', syncPhone);

  form.addEventListener('input', (event) => {
    const cfg = config();
    if (cfg && cfg.oneOf && cfg.oneOf.includes(event.target.id)) updateOneOf();
    event.target.closest('.vb-field, .vb-checkbox')?.classList.remove('is-invalid');
    saveDraft();
  });
  form.addEventListener('change', saveDraft);

  /* Belgio: l'ID Peppol di solito e' 0208: seguito dal numero d'impresa (le cifre della partita IVA). */
  form.addEventListener('focusin', (event) => {
    if (event.target.id !== 'PeppolBE' || event.target.value) return;
    const digits = normalizeVat(vat.value, 'BE').replace(/^BE/, '');
    if (/^[01]\d{9}$/.test(digits)) event.target.placeholder = '0208:' + digits;
  });

  form.addEventListener('submit', handleSubmit, true);
  form.onsubmit = handleSubmit;
})();
